import { emptyV2Api as api } from "../../emptyV2Api";
import { ProductGroupUploadJob } from "../../product/ProductGroupUploadJob";
import { UsimInventoryItem } from "../inventory/inventoryItem";
import { UsimOrderItem, UsimOrderItemData, UsimOrderStatusUpdate, UsimOrderSubmitData } from "./UsimOrderItem";

export const addTagTypes = ["UsimOrders"] as const;
const SLUG = "/usim/orders"
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getUsimOrders: build.mutation<any, {status_list:  string[]}>({
        query: (status) => ({
          url: SLUG + "/manage?action=get_by_status",
          method: "POST",
          body: {"status_list" : status}
        }),
        invalidatesTags: ["UsimOrders"],
      }),
      getUsimOrderbyId: build.query<UsimOrderSubmitData, string>({
        query: (orderNumber) => ({
          url: SLUG + "/manage?id=" + orderNumber,
          method: "GET",
        }),
        providesTags: ["UsimOrders"],
      }),

       getUsimPendingSubmissions: build.query<UsimOrderSubmitData, string>({
        query: () => ({
          url: SLUG + "/manage?action=pendingSubmission",
          method: "GET",
        }),
        providesTags: ["UsimOrders"],
      }),
      
      
      getUsimOrdersByType: build.query<any, string>({
        query: (productType) => ({
          url: SLUG + "/manage?type=" + productType,
          method: "GET",
        }),
        providesTags: ["UsimOrders"],
      }),
      getMarketplaceOrder: build.query<any, string>({
        query: (orderNumber) => ({
          url: SLUG + "/manage?table=marketplace&id=" + orderNumber,
          method: "GET",
        }),
        providesTags: ["UsimOrders"],
      }),
        getUsimOrdersByStatus: build.mutation<any, {status_list:  string[]}>({
        query: (status) => ({
          url: SLUG + "/manage?action=get_by_status",
          method: "POST",
          body: {"status_list" : status.status_list}
        }),
        invalidatesTags: ["UsimOrders"],
      }),
      postUsimOrders: build.mutation<UsimOrderItem, UsimOrderItem>({
        query: (UsimOrders) => ({
          url: SLUG + "/manage",
          method: "POST",
          body: UsimOrders
        }),
        invalidatesTags: ["UsimOrders"],
      }),
      postReqUsimOrderDetail: build.mutation<UsimOrderItem, {orderNumber: string, shopId: number}>({
        query: ({orderNumber, shopId}) => ({
          url: SLUG + "/manage?action=get_detail_order",
          method: "POST",
          body: {
            "orderNumber": orderNumber,
            "shopId" : shopId
          }
        }),
        invalidatesTags: ["UsimOrders"],
      }),
       postUsimRecharge: build.mutation<string, {orderNumber: string, shopId: number}>({
        query: ({orderNumber, shopId}) => ({
          url: SLUG + "/manage?action=recharge",
          method: "POST",
          body: {
            "orderNumber": orderNumber,
            "shopId" : shopId
          }
        }),
        invalidatesTags: ["UsimOrders"],
      }),
       postUsimRechargeStatus: build.mutation<string, {orderNumber: string, shopId: number, orderTid: string}>({
        query: ({orderNumber, shopId, orderTid}) => ({
          url: SLUG + "/manage?action=rechargeStatus",
          method: "POST",
          body: {
            "OrderNumber": orderNumber,
            "shopId" : shopId,
            "orderTid": orderTid
          }
        }),
        invalidatesTags: ["UsimOrders"],
      }),
      putUsimOrders: build.mutation<UsimOrderItem, UsimOrderItem>({
        query: (UsimOrders) => ({
          url: SLUG + "/manage",
          method: "PUT",
          body: UsimOrders,
        }),
        invalidatesTags: ["UsimOrders"],
      }),
      updateUsimOrderStatus: build.mutation<UsimOrderStatusUpdate, UsimOrderStatusUpdate>({
        query: (UsimOrderStatusUpdate) => ({
          url: SLUG + "/manage?action=update_status",
          method: "PUT",
          body: UsimOrderStatusUpdate,
        }),
        invalidatesTags: ["UsimOrders"],
      }),
      cancelUsimOrders: build.mutation<UsimOrderItem, {orderNumber: string, ShopId: number, action: string}>({
        query: ({orderNumber, ShopId, action}) => ({
          url: SLUG + "/manage?action=" + action,
          method: "PUT",
          body: {"id": orderNumber, "shopId": ShopId},
        }),
        invalidatesTags: ["UsimOrders"],
      }),
      //order by iccid,
      getUsimOrderbyIccid: build.query<UsimOrderItemData, string>({
        query: (iccid) => ({
          url: SLUG + "/manage?table=usim&iccid=" + iccid,
          method: "GET",
        }),
        providesTags: ["UsimOrders"],
      }),
      // iccid invetnory calls 
      getUsimOrderIccidInventory: build.query<UsimInventoryItem[], string>({
        query: (iccid) => ({
          url: SLUG + "/manage?table=inventory&iccid=" + iccid,
          method: "GET",
        }),
        providesTags: ["UsimOrders"],
      }),
      // get by mobile number
      getUsimInventoryByMobile: build.query<UsimInventoryItem[], string>({
        query: (mobileNumber) => ({
          url: SLUG + "/manage?table=inventory&mobileNumber=" + mobileNumber,
          method: "GET",
        }),
        providesTags: ["UsimOrders"],
      }),
       getUsimOrdersUploadJobs: build.query<ProductGroupUploadJob[], void>({
      query: () => SLUG + "/upload",
    }),
    getKycPhotoDownloadUrl: build.query<{downloadUrl: string}, {orderNumber: string, shopId: number}>({
      query: ({orderNumber, shopId}) => ({
        url: SLUG + "/manage?action=downloadKycPhoto&orderNumber=" + encodeURIComponent(orderNumber) + "&shopId=" + encodeURIComponent(shopId.toString()),
        method: "GET",
      }),
    }),
      
    }),
  });

export const {
  useGetUsimOrdersMutation,
  useGetUsimOrderbyIdQuery,
  useGetUsimPendingSubmissionsQuery,
  useGetMarketplaceOrderQuery,
  useGetUsimOrdersByStatusMutation,
  useGetUsimOrderbyIccidQuery,
  useGetUsimOrderIccidInventoryQuery,
  useGetUsimOrdersByTypeQuery,
  useGetUsimInventoryByMobileQuery,
  usePostUsimOrdersMutation,
  usePostReqUsimOrderDetailMutation,
  usePostUsimRechargeMutation,
  usePostUsimRechargeStatusMutation,
  usePutUsimOrdersMutation,
  useUpdateUsimOrderStatusMutation,
  useCancelUsimOrdersMutation,
  useGetUsimOrdersUploadJobsQuery,
  useGetKycPhotoDownloadUrlQuery,
} = injectedRtkApi;
